import { INTEREST_PREVIEW } from "constants/actionTypes";

import { apiModelOfflineFetchReducer } from "lib/reducers";
import { deserializeInterestPreview } from "lib/serializers/interestPreview";

const fetchReducer = apiModelOfflineFetchReducer(INTEREST_PREVIEW, {
  deserializer: deserializeInterestPreview,
  clearOnRequest: true,
});

export default (state, action) => {
  // A response to a request that was since superseded or reset would
  // overwrite the current preview, so only the latest request's counts.
  if (
    (action.type === INTEREST_PREVIEW.FETCH_BULK.SUCCESS ||
      action.type === INTEREST_PREVIEW.FETCH_BULK.FAILURE) &&
    action.meta?.requestId !== state?.requestId
  ) {
    return state;
  }

  const nextState = fetchReducer(state, action);

  switch (action.type) {
    case INTEREST_PREVIEW.FETCH_BULK.REQUEST:
      return { ...nextState, requestId: action.meta.requestId };
    case INTEREST_PREVIEW.CREATE.REQUEST:
      return { ...nextState, isCreating: true };
    case INTEREST_PREVIEW.CREATE.SUCCESS:
    case INTEREST_PREVIEW.CREATE.FAILURE:
      return { ...nextState, isCreating: false };
    default:
      return nextState;
  }
};
